module.exports = __webpack_public_path__ + "img/tonghua.e14dd524.png";